import { TranslationKey, useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement, ReactNode } from 'react';
import { S_ConfirmationModal } from '../../../../../../design/modals/confirmationModal/S_ConfirmationModal';

interface Props {
  headerKey: TranslationKey;
  show: boolean;
  onHide: () => void;
  onSubmit: () => Promise<void>;
  children?: ReactNode;
}

export const MarkingToolModal = observer((props: Props): ReactElement => {
  const { t } = useTranslator();

  return (
    <S_ConfirmationModal
      cancelText={t('new.projects.details.marking_tools.cancel')}
      headerText={t(props.headerKey)}
      submitText={t('new.projects.details.marking_tools.confirm')}
      onCancel={props.onHide}
      toggle={props.onHide}
      onSubmit={props.onSubmit}
      isOpen={props.show}
      loaderKey='add-or-edit-marking-tool-key'
    >
      {props.children}
    </S_ConfirmationModal>
  );
});
